export const anomaliesTranslations = {
  ru: {
    'anomalies.page.title': 'Аномалии платежей',
    'anomalies.page.subtitle': 'Проведённые, но не подтверждённые сверкой платежи и другие расхождения',
    'anomalies.filter.status': 'Статус: {status}',
    'anomalies.column.severity': 'Severity',
    'anomalies.column.status': 'Status',
    'anomalies.column.type': 'Type',
    'anomalies.column.document': 'Document',
    'anomalies.column.posting': 'Posting',
    'anomalies.column.expectedUnpaid': 'Expected unpaid',
    'anomalies.column.actualUnpaid': 'Actual unpaid',
    'anomalies.column.detected': 'Detected',
    'anomalies.column.actions': 'Actions',
    'anomalies.action.acknowledge': 'Acknowledge',
    'anomalies.action.resolve': 'Resolve',
    'anomalies.empty.title': 'Аномалий нет',
    'anomalies.detail.notFound': 'Аномалия не найдена',
    'anomalies.detail.title': 'Аномалия {id}…',
    'anomalies.detail.acknowledge': 'Подтвердить (Acknowledge)',
    'anomalies.detail.resolve': 'Закрыть (Resolve)',
    'anomalies.detail.statusLabel': 'Статус: {status}',
    'anomalies.detail.document': 'Документ',
    'anomalies.detail.documentType': 'Тип документа',
    'anomalies.detail.expectedUnpaid': 'Ожидаемая задолженность',
    'anomalies.detail.actualUnpaid': 'Фактическая задолженность',
    'anomalies.detail.expectedStatus': 'Ожидаемый статус',
    'anomalies.detail.actualStatus': 'Фактический статус',
    'anomalies.detail.posting': 'Posting',
    'anomalies.detail.detected': 'Обнаружена',
    'anomalies.detail.openPosting': 'Открыть проведение и evidence',
    'anomalies.backOffice.title': 'Проверка в Syrve BackOffice',
    'anomalies.backOffice.description': 'Запишите фактическое состояние документа после ручной проверки в Syrve. Запись не выполняет повторное проведение.',
    'anomalies.backOffice.paymentExists': 'Платёж существует в BackOffice',
    'anomalies.backOffice.actualPaid': 'Фактически оплачено',
    'anomalies.backOffice.actualUnpaid': 'Фактическая задолженность',
    'anomalies.backOffice.actualStatus': 'Фактический статус',
    'anomalies.backOffice.note': 'Комментарий',
    'anomalies.backOffice.resolveIfMatch': 'Подтвердить ручную сверку, если значения совпадают с ожидаемыми',
    'anomalies.backOffice.submit': 'Записать проверку BackOffice',
    'anomalies.backOffice.leaveOpen': 'Оставить аномалию открытой',
    'anomalies.backOffice.noteVerified': 'Проверка BackOffice',
    'anomalies.backOffice.noteLeftOpen': 'Оставлено открытым',
  },
  en: {
    'anomalies.page.title': 'Payment anomalies',
    'anomalies.page.subtitle': 'Posted but unreconciled payments and other discrepancies',
    'anomalies.filter.status': 'Status: {status}',
    'anomalies.column.severity': 'Severity',
    'anomalies.column.status': 'Status',
    'anomalies.column.type': 'Type',
    'anomalies.column.document': 'Document',
    'anomalies.column.posting': 'Posting',
    'anomalies.column.expectedUnpaid': 'Expected unpaid',
    'anomalies.column.actualUnpaid': 'Actual unpaid',
    'anomalies.column.detected': 'Detected',
    'anomalies.column.actions': 'Actions',
    'anomalies.action.acknowledge': 'Acknowledge',
    'anomalies.action.resolve': 'Resolve',
    'anomalies.empty.title': 'No anomalies',
    'anomalies.detail.notFound': 'Anomaly not found',
    'anomalies.detail.title': 'Anomaly {id}…',
    'anomalies.detail.acknowledge': 'Acknowledge',
    'anomalies.detail.resolve': 'Resolve',
    'anomalies.detail.statusLabel': 'Status: {status}',
    'anomalies.detail.document': 'Document',
    'anomalies.detail.documentType': 'Document type',
    'anomalies.detail.expectedUnpaid': 'Expected unpaid amount',
    'anomalies.detail.actualUnpaid': 'Actual unpaid amount',
    'anomalies.detail.expectedStatus': 'Expected status',
    'anomalies.detail.actualStatus': 'Actual status',
    'anomalies.detail.posting': 'Posting',
    'anomalies.detail.detected': 'Detected',
    'anomalies.detail.openPosting': 'Open posting and evidence',
    'anomalies.backOffice.title': 'Syrve BackOffice verification',
    'anomalies.backOffice.description': 'Record the actual document state after manual verification in Syrve. This does not re-post the payment.',
    'anomalies.backOffice.paymentExists': 'Payment exists in BackOffice',
    'anomalies.backOffice.actualPaid': 'Actually paid',
    'anomalies.backOffice.actualUnpaid': 'Actual unpaid amount',
    'anomalies.backOffice.actualStatus': 'Actual status',
    'anomalies.backOffice.note': 'Comment',
    'anomalies.backOffice.resolveIfMatch': 'Confirm manual reconciliation if values match expected',
    'anomalies.backOffice.submit': 'Record BackOffice verification',
    'anomalies.backOffice.leaveOpen': 'Leave anomaly open',
    'anomalies.backOffice.noteVerified': 'BackOffice verification',
    'anomalies.backOffice.noteLeftOpen': 'Left open',
  },
  id: {
    'anomalies.page.title': 'Anomali pembayaran',
    'anomalies.page.subtitle': 'Pembayaran yang diposting tetapi belum direkonsiliasi dan ketidaksesuaian lainnya',
    'anomalies.filter.status': 'Status: {status}',
    'anomalies.column.severity': 'Severity',
    'anomalies.column.status': 'Status',
    'anomalies.column.type': 'Type',
    'anomalies.column.document': 'Document',
    'anomalies.column.posting': 'Posting',
    'anomalies.column.expectedUnpaid': 'Expected unpaid',
    'anomalies.column.actualUnpaid': 'Actual unpaid',
    'anomalies.column.detected': 'Detected',
    'anomalies.column.actions': 'Actions',
    'anomalies.action.acknowledge': 'Acknowledge',
    'anomalies.action.resolve': 'Resolve',
    'anomalies.empty.title': 'Tidak ada anomali',
    'anomalies.detail.notFound': 'Anomali tidak ditemukan',
    'anomalies.detail.title': 'Anomali {id}…',
    'anomalies.detail.acknowledge': 'Acknowledge',
    'anomalies.detail.resolve': 'Resolve',
    'anomalies.detail.statusLabel': 'Status: {status}',
    'anomalies.detail.document': 'Dokumen',
    'anomalies.detail.documentType': 'Tipe dokumen',
    'anomalies.detail.expectedUnpaid': 'Tunggakan yang diharapkan',
    'anomalies.detail.actualUnpaid': 'Tunggakan aktual',
    'anomalies.detail.expectedStatus': 'Status yang diharapkan',
    'anomalies.detail.actualStatus': 'Status aktual',
    'anomalies.detail.posting': 'Posting',
    'anomalies.detail.detected': 'Terdeteksi',
    'anomalies.detail.openPosting': 'Buka posting dan evidence',
    'anomalies.backOffice.title': 'Verifikasi Syrve BackOffice',
    'anomalies.backOffice.description': 'Catat status dokumen aktual setelah verifikasi manual di Syrve. Ini tidak memposting ulang pembayaran.',
    'anomalies.backOffice.paymentExists': 'Pembayaran ada di BackOffice',
    'anomalies.backOffice.actualPaid': 'Dibayar aktual',
    'anomalies.backOffice.actualUnpaid': 'Tunggakan aktual',
    'anomalies.backOffice.actualStatus': 'Status aktual',
    'anomalies.backOffice.note': 'Komentar',
    'anomalies.backOffice.resolveIfMatch': 'Konfirmasi rekonsiliasi manual jika nilai cocok dengan yang diharapkan',
    'anomalies.backOffice.submit': 'Catat verifikasi BackOffice',
    'anomalies.backOffice.leaveOpen': 'Biarkan anomali terbuka',
    'anomalies.backOffice.noteVerified': 'Verifikasi BackOffice',
    'anomalies.backOffice.noteLeftOpen': 'Dibiarkan terbuka',
  },
} as const;
